var _effectorFileName = "/src/shared/components/promo-modal/lib.ts";
export const AD_PROMO_QUERY = 'adfornew';
export const AD_PROMO_DISMISSED_KEY = 'ad_promo_dismissed';
export const AD_PROMO_VIEW_TRACKED_KEY = 'ad_promo_view_tracked';
export const normalizeQueryParam = (value: string | string[] | undefined) => {
  if (Array.isArray(value)) return value[0];
  return value;
};
export const shouldSchedulePromo = (queryValue: string | string[] | undefined, dismissed: boolean) => {
  return normalizeQueryParam(queryValue) === 'true' && !dismissed;
};
export const isPromoDismissed = () => {
  if (typeof window === 'undefined') return false;
  return window.sessionStorage.getItem(AD_PROMO_DISMISSED_KEY) === '1';
};
export const dismissPromo = () => {
  if (typeof window === 'undefined') return;
  window.sessionStorage.setItem(AD_PROMO_DISMISSED_KEY, '1');
};
export const hasTrackedPromoView = () => {
  if (typeof window === 'undefined') return false;
  return window.sessionStorage.getItem(AD_PROMO_VIEW_TRACKED_KEY) === '1';
};
export const markPromoViewTracked = () => {
  if (typeof window === 'undefined') return;
  window.sessionStorage.setItem(AD_PROMO_VIEW_TRACKED_KEY, '1');
};